const STEP_LABELS = ['Account', 'Business Profile', 'Location']

interface StepIndicatorProps {
  currentStep: number
  totalSteps?: number
  labels?: string[]
}

export default function StepIndicator({
  currentStep,
  totalSteps = 3,
  labels = STEP_LABELS,
}: StepIndicatorProps) {
  return (
    <div className="w-full mb-6">
      {/* Step circles + labels */}
      <div className="flex justify-between mb-3">
        {Array.from({ length: totalSteps }, (_, i) => {
          const step = i + 1
          const isCompleted = step < currentStep
          const isCurrent = step === currentStep
          return (
            <div key={step} className="flex flex-col items-center flex-1">
              <div
                aria-hidden="true"
                className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold mb-1.5 transition-all duration-200
                  ${isCompleted
                    ? 'bg-rd-accent text-rd-bg'
                    : isCurrent
                    ? 'bg-rd-accent text-rd-bg ring-4 ring-rd-accent/20'
                    : 'bg-white/[0.07] text-rd-dim border border-white/[0.07]'
                  }`}
              >
                {isCompleted ? (
                  <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                ) : (
                  step
                )}
              </div>
              <span
                className={`text-xs text-center leading-tight hidden sm:block font-medium
                  ${isCurrent ? 'text-rd-accent' : 'text-rd-dim'}`}
              >
                {labels[i] ?? `Step ${step}`}
              </span>
            </div>
          )
        })}
      </div>

      {/* Progress bar */}
      <span className="sr-only">{`Step ${currentStep} of ${totalSteps}`}</span>
      <div
        role="progressbar"
        aria-label={`Step ${currentStep} of ${totalSteps}: ${labels[currentStep - 1] ?? ''}`}
        aria-valuenow={currentStep}
        aria-valuemin={1}
        aria-valuemax={totalSteps}
        className="w-full h-1 bg-white/[0.07] rounded-full overflow-hidden"
      >
        <div
          className="h-full bg-rd-accent rounded-full transition-all duration-300 ease-in-out"
          style={{ width: `${Math.round((currentStep / totalSteps) * 100)}%` }}
        />
      </div>
    </div>
  )
}
